var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.4%",
    y: "-.6%",
    width: "100.8%",
    height: "101.6%",
    filterUnits: "objectBoundingBox",
    id: "plrj0imhxa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "5180qexf6b",
    x: 230,
    y: 200,
    width: 980,
    height: 644,
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343C17",
    opacity: 0.9,
    d: "M-294-748h1440V276H-294z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-294 -748)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#plrj0imhxa)",
    xlinkHref: "#5180qexf6b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F7F3EF",
    xlinkHref: "#5180qexf6b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EAE2D6",
    width: 666,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#717832",
    cx: 16,
    cy: 16,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717832",
    cx: 16,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#717832",
    x: 15,
    y: 6,
    width: 2,
    height: 14,
    rx: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGreen);
export default __webpack_public_path__ + "static/media/alert-green.8836f2e206aeed30a5a739081dba58b3.svg";
export { ForwardRef as ReactComponent };